<template lang="pug">
  v-card.mx-auto.estates-chart
    v-card-title 
      div Casos por estado
      v-spacer
      .float-right(v-if="dayInformation[0]") {{dayInformation[0].date | date-format-string}}
    GChart(v-if="chartData.length > 0", type="BarChart", :data="chartData", :options="chartOptions")
    v-card-text.text--primary
      div Casos por estado
</template>

<script>
import estates from '@/assets/layers/estates'

import { GChart } from 'vue-google-charts'

import utilService from '@/services/util'

export default {
  components: {
    GChart
  },
  props: {
    dayInformation: {
      type: Array
    },
    limit: {
      type: Number,
      default: 32
    }
  },
  data() {
    return {
      chartData: [],
      chartOptions: {
        // title: 'Confirmados por día',
        // subtitle: 'Casos confirmados',
        legend: { position: 'bottom' },
        chartArea: { height: '90%' },
        height: 700
      }
    }
  },
  watch: {
    dayInformation: function() {
      this.reloadChart()
    }
  },
  methods: {
    reloadChart() {
      this.chartData = [['Día', 'Confirmados acumulados']]
      for (let i = 0; i < this.dayInformation.length && i < this.limit; i++) {
        // if (i < 10) {
        this.chartData.push([
          utilService.findObjectByKey(estates, 'CVE_ENT', this.dayInformation[i].estateId).NOM_ENT,
          this.dayInformation[i].confirmed
        ])
      }
    }
  },
  mounted() {
    this.reloadChart()
  }
}
</script>

<style>
.estates-chart {
  /* height: 800px; */
}
</style>
